import { useTranslation } from 'react-i18next';
import { supplierFactories } from '@/mocks/supplierNetwork';
import FactoryCard from './FactoryCard';

export default function FactoryShowcase() {
  const { t } = useTranslation('supplierNetwork');

  return (
    <section id="factories" className="w-full bg-cream-50 py-12 md:py-16 lg:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="text-xs font-semibold text-warm-500 uppercase tracking-[0.2em] mb-3 block">
              {t('factories.label')}
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ink-700 mb-4">
              {t('factories.title')}
            </h2>
            <p className="text-sm md:text-base text-ink-400 max-w-2xl mx-auto">
              {t('factories.subtitle')}
            </p>
            <div className="w-16 h-1 bg-warm-500 mx-auto mt-6 rounded-full" />
          </div>

          {/* Factory list */}
          <div className="space-y-10 md:space-y-14">
            {supplierFactories.map((factory, index) => (
              <FactoryCard key={factory.id} factory={factory} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}